import { ItemsPerPageSelector } from "@/features/common/components/pagination/ItemsPerPageSelector";
import { ModelInstagramOrderByFilter } from "@/features/model/components/modeList/filter/ModelInstagramOrderByFilter";
import { ModelQuickFilterRow } from "@/features/model/components/modeList/filter/ModelQuickFilterRow";
import { SaveModelFilter } from "@/features/model/components/modeList/filter/SavedModelFilter";

export const ModelListFilterSection = () => {
  return (
    <div className="items-center gap-2 flex flex-wrap">
      <ModelQuickFilterRow />
      <ModelInstagramOrderByFilter />
      <SaveModelFilter />

      <div className="ml-auto">
        <ItemsPerPageSelector />
      </div>
    </div>
  );
};
